import React, { Component } from 'react'
import DataTable from 'react-data-table-component';
import FilterComponent from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit,faTrash,faUser,faPlus} from '@fortawesome/free-solid-svg-icons';
import AddTrainingQuestion from './AddTrainingQuestion'
import AssignTraining from './AssignTraining';
import AddTraining from './AddTraining';
import axios from 'axios';
import { API } from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import ToastComp from '../../../components/Toast/Toast';
import EditQuestions from './EditQuestions';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import toast from 'react-hot-toast';

export default class Training extends Component {
  
constructor(){
    super();
   // this.columns = TableConfig.columnsCommunication;
    this.columns = [
      {
        id:"id",
          name: 'ID',
          selector: row => row.id,
          grow:0.5
      },
      {
          name: 'TITLE',
          selector: row => row.name,
          grow:2
      },
      {
        name: 'CREATED DATE',
        selector: row => row.validfrom,
      },
      {
        name: 'EXPIRY DATE',
        selector: row => row.validto,
      },
      {
        cell:(row) => <button id={row.id} className='btn btn-success'  onClick={()=>this.addQuestion(row.id)}> <FontAwesomeIcon icon={faPlus} className='table-icon-inline'/> QUESTION</button>,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width:"150px"
      },
      {
        cell:(row) => <button id={row.id} className='btn btn-info' onClick={()=>this.editTraining(row)}> <FontAwesomeIcon icon={faEdit} className='table-icon-inline'/>EDIT</button>,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        cell:(row) => <button id={row.id} className='btn btn-danger' onClick={()=>this.deleteTraining(row.id)}> <FontAwesomeIcon icon={faTrash} className='table-icon-inline'/>DELETE</button>,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        cell:(row) => <button id={row.id} className='btn btn-warning' onClick={()=>this.assignTrainCourse(row)}> <FontAwesomeIcon icon={faUser} className='table-icon-inline'/>ASSIGN</button>,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
  ]
    this.state = {
      data : [],
      fullData:[],
      toggleForm : false,
      toggleAssignForm : false,
      toggleAddForm:false,
      editForm :  false,
      loader : false,
      assignAlert:false,
      errorAlert:false,
      deleteAlert:false,
      unassignAlert:false,
      editQ:false
    }
    this.trainingId ='';
    this.trainingOj={};
    this.trainingQuestion=[];
    
}
addQuestion =(id)=>{
  this.trainingId = id;
  this.setState({toggleForm : true});  
}
updateToggleFormVal = ()=>{
  this.setState({toggleForm : false});
}
updateToggleAssignFormVal =()=>{
  this.setState({toggleAssignForm : false});
}
updateToggleAddFormVal=()=>{
  this.setState({toggleAddForm : false});
}
assignTrainCourse=(row)=>{
  this.trainingId = row.id;
  this.trainingOj = row;
  this.setState({toggleAssignForm : true});
}
editTraining =(row)=>{
  this.trainingOj=row;
  this.setState({editForm : true});
}
updateToggleEdit =()=>{
  this.setState({editForm : false});
}
componentDidMount(){
  this.loadTrainings();
}

//Search fn
filterData = (e)=>{
  const key = e.target.value;
  let ar=[];
  this.state.fullData.forEach(element => {
    if(element.name.toLowerCase().indexOf(key.toLowerCase())>-1) 
    ar.push(element);
  });
  this.setState({data : ar})
}

loadTrainings =()=>{
  this.setState({toggleAddForm:false});
  this.setState({editForm:false});
  this.setState({loader : true});

  axios.get(API.listTraining).then((res)=>{
    this.setState({loader:false});
    if(res.status === 200 && res.data && res.data.status === "S"){
      this.setState({data : res.data.trainings});
      this.setState({fullData: res.data.trainings})
    }
  }).catch((er)=>{
    this.setState({loader:false});
  })
}

//unassign training
unAssignTraining = (data)=>{
  this.setState({loader : true});
  const req ={
    trainingId: this.trainingId.toString(),
    dueDate : data.dueDate,
  }
  const typeMap = {
    D : 'groupId',
    P : 'project',
    L : 'level'
  }
  //attach project/level/groupId key
  req[typeMap[data.type]] = data.selected;
  axios.post(API.unAssignTraining, req).then((res)=>{
    if(res && res.data && res.data.status === 'S'){
      this.setState({unassignAlert:true});
    }else{
      this.setState({errorAlert:true});
    }
  }).catch((er)=>{
    this.setState({errorAlert:true});
  }).finally(()=>{
    setTimeout(() => {
      this.setState({loader : false});
      this.setState({toggleAssignForm : false});
      this.loadTrainings();
    }, 1000);
  })
}

//assign training to department
assignTraining = (data)=>{
  this.setState({loader : true});
  const req ={
    trainingId: this.trainingId.toString(),
    dueDate : data.dueDate
  }
  const typeMap = {
    D : 'groupId',
    P : 'project',
    L : 'level'
  }
  //attach project/level/groupId key
  req[typeMap[data.type]] = data.selected;
  axios.post(API.assignTrainingToUser, req).then((res)=>{
    if(res && res.data && res.data.status === 'S'){
      this.setState({assignAlert:true});
    }else{
      this.setState({errorAlert:true});
    }
  }).catch((er)=>{
    this.setState({errorAlert:true});
  }).finally(()=>{
    setTimeout(() => {
      this.setState({loader : false});
      this.setState({toggleAssignForm : false});
      this.loadTrainings();
    }, 1000);
  })
}

//delete training
deleteTraining=(id)=>{
  confirmAlert({
    message: 'Are you sure you want to delete?',
    buttons: [
      {
        label: 'YES',
        className:'btn btn-success',
        onClick: () => {
          this.setState({loader : true});
          axios.post(API.deleteTraining, {id}).then((res)=>{
            if(res && res.data && res.data.status === 'S'){
              // this.setState({deleteAlert:true});
              toast.success('Training deleted successfully.');
            }else{
              // this.setState({errorAlert:true});
              toast.error('Failed to delete training.');
            }
          }).catch((er)=>{
            this.setState({errorAlert:true});
            toast.error('An error occurred while deleting training.');
          }).finally(()=>{
            setTimeout(() => {
              this.setState({loader : false});
              this.loadTrainings();
            }, 1000);
          })
        },
      },
      {
        label: 'CANCEL',
        className:'btn btn-error',
        onClick: () => {},
      },
    ],
  });
}

goToEditQuesion =()=>{
  this.setState({editForm:false})
  this.setState({loader : true});
  axios.get(API.getTrainingDetail+this.trainingOj.id).then((res)=>{
    this.setState({loader : false});
    if(res && res.data && res.data.status === 'S'){
      console.log(res.data.trainingData);
      this.trainingQuestion = res.data.trainingData;
      this.setState({editQ : true});
    }else{
      this.setState({errorAlert:true});
    }
  }).catch((er)=>{
    this.setState({loader : false});
    this.setState({errorAlert:true});
  })
}

deleteTrQuestion = (id)=>{
  this.setState({editQ:false});
  this.setState({loader : true});
  const req={
    trainingId: this.trainingOj.id,
    dataId: [id]
  }
  axios.post(API.deleteTrainingQuestion, req).then((res)=>{
    if(res && res.data && res.data.status === 'S'){
      // this.setState({deleteAlert:true});
      toast.success('Question deleted successfully.');
    }else{
      // this.setState({errorAlert:true});
      toast.error('Failed to delete question.');
    }
  }).catch((er)=>{
    // this.setState({errorAlert:true});
    toast.error('An error occurred while deleting question.');
  }).finally(()=>{
    setTimeout(() => {
      this.setState({loader : false});
      this.loadTrainings();
    }, 1000);
  })

}

  render() {
    
    return (
      <div>
        <Loader loading={this.state.loader}></Loader>
        {this.state.assignAlert ? <ToastComp case='assign-user' handler={()=>{this.setState({assignAlert:false})}}/> : ""}
        {this.state.unassignAlert ? <ToastComp case='unassign-user' handler={()=>{this.setState({unassignAlert:false})}}/> : ""}
        {this.state.errorAlert ? <ToastComp case='error' handler={()=>{this.setState({errorAlert:false})}}/> : ""}
        {this.state.deleteAlert ? <ToastComp case='delete' handler={()=>{this.setState({deleteAlert:false})}}/> : ""}

        {this.state.editForm ? <AddTraining editQ={this.goToEditQuesion} edit={true} data ={this.trainingOj} callback={this.loadTrainings} handler={this.updateToggleEdit} flag={this.state.editForm? true : false}/> : ''}
        {this.state.toggleAddForm ? <AddTraining callback={this.loadTrainings} handler={this.updateToggleAddFormVal} flag={this.state.toggleAddForm? true : false}/> : ''}
        {this.state.toggleForm ? <AddTrainingQuestion id={this.trainingId} handler={this.updateToggleFormVal} flag={this.state.toggleForm? true : false}/> : ''}
        {this.state.toggleAssignForm ? <AssignTraining data={this.trainingOj} unassign={(data)=>{this.unAssignTraining(data)}} assign={(data)=>{this.assignTraining(data)}} handler={this.updateToggleAssignFormVal} flag={this.state.toggleAssignForm? true : false} /> : ''}
        {this.state.editQ ? <EditQuestions deleteCB={(id)=>this.deleteTrQuestion(id)} data={this.trainingQuestion} flag={this.state.editQ ? true : false} handler={()=> this.setState({editQ:false})}/>:""}
   
      <div className='bread-crumb overflow-auto'>
      <div>
      <span className='breadcrumb-title'>
        <input type='button' className='btn' value='Home - Training'></input>
      </span>
      <span className='fr'>
        <input type='button' className='btn btn-success' value='ADD TRAINING' onClick={()=>this.setState({toggleAddForm:true})}></input>
      </span>
      </div>
      </div>
      <div className='data-table-holder'>
        <div className='table-search-box'>
        {/* <FontAwesomeIcon icon={faSearch} className='table-icon-inline'/>  */}
        <input type='text' placeholder="Search Here.." className='form-control' onChange={(e)=>this.filterData(e)}></input>
        </div>
      <DataTable
      columns={this.columns} defaultSortFieldId="id"
      data={this.state.data} pagination striped
     
      />
      </div>
      </div>
    )
  }
}
